import React from "react"
import { graphql, useStaticQuery } from "gatsby"
export interface VisualCortexBlockProps {}
const video = require("../images/video/vcx-video.mp4") as string
const VisualCortexBlock: React.SFC<VisualCortexBlockProps> = () => {
  const query = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "header_banner/eye.jpg" }) {
        relativePath
        base
        childImageSharp {
          fluid(maxHeight: 150, maxWidth: 240, jpegQuality: 70) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const banner = require("../images/header_banner/eye.jpg") as string
  return (
    <>
      <div className="container-full block-visualCortex">
        <div className="row no-gutters row-banner-hero">
          <div className="backdrop-bg"></div>
          <div className="col-lg-6 block-visualCortex__header">
            <h3 className="u-text-center u-font-family-roboto">VisualCortex</h3>
            <span>人間の視覚をつくる</span>
          </div>
          <video
            className="video-player"
            height="100%"
            width="100%"
            loop
            muted
            autoPlay
          >
            <source src={video} type="video/mp4" />
          </video>
          {/* <div className="col-lg-6">
          <Img fluid={query.file.childImageSharp.fluid} />
        </div> */}
        </div>
      </div>
      <div className="container">
        <p className="text-hero">
        人型AIプラットフォーム「LUDENS」の視覚を担うプロダクト「VisualCortex」。人間の視覚のように空間情報をマッピングし、その集合領域の特徴から、動き、姿勢、表情、視線などをリアルタイムに分析します。
        </p>
      </div>
    </>
  )
}

export default VisualCortexBlock
